import { CliaCertificate, Lab } from "pwapi";

import { LabList } from "custom-models/frontLoader";

export const isAZDPName = (name?: string) => {
  if (!name) return false;
  return (
    name.toLowerCase() === "azdp" ||
    name.toLowerCase() === "arizona dermatopathology"
  );
};
export const isAZDPLab = (lab?: Lab | LabList) => {
  if (!lab) return false;
  return isAZDPName(lab.name);
};
export const isAZDPCert = (cert?: CliaCertificate) => {
  if (!cert) return false;
  return isAZDPName(cert.name) || isAZDPLab(cert.lab);
};

export const isPropathName = (name?: string) => {
  if (!name) return false;
  return name.toLowerCase().includes("propath");
};
export const isPropathLab = (lab?: Lab | LabList) => {
  if (!lab) return false;
  return isPropathName(lab.name);
};
export const isPropathCert = (cert?: CliaCertificate) => {
  if (!cert) return false;
  return isPropathName(cert.name) || isPropathLab(cert.lab);
};

export const isDermDXName = (name?: string) => {
  if (!name) return false;
  return (
    name.toLowerCase().includes("dermdx new england") ||
    name.toLowerCase().includes("dermpath new england")
  );
};
export const isDermDXLab = (lab?: Lab | LabList) => {
  if (!lab) return false;
  return isDermDXName(lab.name);
};
export const isDermDXCert = (cert?: CliaCertificate) => {
  if (!cert) return false;
  return isDermDXName(cert.name) || isDermDXLab(cert.lab);
};

export const isConsultantsInLaboratoryMedicineCert = (
  cert?: CliaCertificate
) => {
  if (!cert) return false;
  return isPromedicaCert(cert);
};

export const isPromedicaCert = (cert?: CliaCertificate) => {
  if (!cert) return false;
  return cert.name.toLowerCase().includes("promedica monroe regional hospital");
};

export const isPSPCCert = (cert?: CliaCertificate) => {
  if (!cert) return false;
  return (
    cert.name === "Pathology Services, A Professional Corporation" ||
    cert.name === "Pathology Services, PC" ||
    cert.name === "Pathology Services, Inc."
  );
};

export const isBiopsyDiagnosticsCert = (cert?: CliaCertificate) => {
  if (!cert) return false;
  return cert.name.includes("Biopsy Diagnostics");
};

export const isSouthTexasCert = (cert?: CliaCertificate) => {
  if (!cert) return false;
  return cert.name.includes("South Texas Dermatopathology");
};

export const appendSendoutIfNeeded = (name?: string) => {
  if (!name) return "";
  return name.includes("Sendout") ? name : `${name} Sendout`;
};
